const AddParticipants = () => {
  const participantsModalElements = document.querySelectorAll('.woocommerce-cart-form .participants-modal');
  if( !participantsModalElements ) return;

  const portalElement = document.getElementById('cart-add-participants-forms');
  // Move elements outside of Cart  Item Form. 
  participantsModalElements.forEach( participantsModalElement => {
    const divFormElement = participantsModalElement.querySelector('.participants-form');
    const form = document.createElement('form');
    form.innerHTML = divFormElement.innerHTML;
    form.action = divFormElement.getAttribute('action') ?? '';
    form.method = divFormElement.getAttribute('method') ?? 'POST';
    form.classList.add('participants-form');
    participantsModalElement.querySelector('.participants-modal-inner').appendChild(form);
    divFormElement.remove();
  });

  const addParticipantsButtonElement = document.querySelectorAll('.js-add-participant');
  addParticipantsButtonElement.forEach( element => element.addEventListener('click', () => {
    const selectedParticipantsModalElement = [...participantsModalElements]?.filter( modalElement => modalElement.dataset.product_id === element.dataset.id)[0] ?? null;
    selectedParticipantsModalElement?.classList.add('active');
    document.querySelector('body').classList.add('no-scroll')
  }));

  document.querySelectorAll('.participants-modal').forEach( participantsModalElement => {
    let currentPage = 1;
    const pages = participantsModalElement.querySelectorAll('.participant').length;
    const nextButtonElement = participantsModalElement.querySelector('button.next');
    const prevButtonElement = participantsModalElement.querySelector('button.prev');
    const submitButtonElement = participantsModalElement.querySelector('.submit');
    const cancelButtonElement = participantsModalElement.querySelector('.cancel');

    prevButtonElement?.addEventListener('click', (e) => {
      e.preventDefault();
      const currentActiveParticipant = participantsModalElement.querySelector('.participant.is-active');
      
      if(currentActiveParticipant.previousElementSibling ) {
        currentActiveParticipant.classList.remove('is-active');
        currentActiveParticipant.previousElementSibling.classList.add('is-active');
        nextButtonElement.style.display = 'block';
        submitButtonElement.style.display = 'none';
        currentPage--;
      }
      if(currentPage === 1) {
        prevButtonElement.style.display = 'none';
      }
    })

    nextButtonElement?.addEventListener('click', (e) => {
      e.preventDefault();
      const currentActiveParticipant = participantsModalElement.querySelector('.participant.is-active');
      
      if( currentActiveParticipant.nextElementSibling ) {
        if( validateFields( currentActiveParticipant ) ) {
          currentActiveParticipant.classList.remove('is-active');
          currentActiveParticipant.nextElementSibling.classList.add('is-active');
          prevButtonElement.style.display = 'block';
          currentPage++;
        }
      }
      if( currentPage === pages) {
        nextButtonElement.style.display = 'none';
        submitButtonElement.style.display = 'block';
      }
    })

    submitButtonElement.addEventListener('click', (e) => {
      if( !validateFields( participantsModalElement.querySelector('.participant.is-active') )) {
        e.preventDefault();
      }
    })

    cancelButtonElement.addEventListener('click', (e) => {
      participantsModalElement.classList.remove('active'); 
      document.querySelector('body').classList.remove('no-scroll')
    })
  });
  onCartQtyChange();
}

const validateFields = ( currentActiveParticipant ) => {
  const requiredElements = currentActiveParticipant.querySelectorAll('[required]');
  let isValid = true; 

  requiredElements.forEach( requiredInput => {
    const inputControlElement = requiredInput.closest('.input-control');
    let hasValue = requiredInput.type === 'radio' ? requiredInput.checked : !!requiredInput.value;

    switch(requiredInput.type) {
      case 'email':
        hasValue = !!requiredInput.value.match(/^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]+$/)
        break;
      case 'radio':
        hasValue = !!inputControlElement.querySelector('input[type="radio"]:checked');
        break;
    }

    if( !hasValue ) { 
      inputControlElement.classList.add('is-invalid');
      requiredInput.addEventListener('input', (e) => 
        e.currentTarget.value ? inputControlElement.classList.remove('is-invalid') : inputControlElement.classList.add('is-invalid'))
        isValid = false;
    }
  })
  return isValid
}


// Rerender elements on Qty. change.
const onCartQtyChange = () => {
  
   const cart_observer = new MutationObserver(() => {
      const portalElement = document.getElementById('cart-add-participants-forms');
      portalElement.replaceChildren();
      AddParticipants();
    });

    cart_observer.observe(document.querySelector('.cart-collaterals'), {
      childList: true,
      subtree: true
    });

}

export default AddParticipants;